import { useEffect, useState } from 'react'

export function useRegistry(client) {
  const [n, setN] = useState(0)
  const registry = client.registry
  useEffect(() => {
    const onRegistryChange = () => {
      setN(n => n + 1)
    }
    registry.on('change', onRegistryChange)
    return () => {
      registry.off('change', onRegistryChange)
    }
  }, [])
  return [registry, n]
}
